export default "__VITE_ASSET__D$EZjT7N__"